// import React from "react";
// import { ReactComponent as DuroltLogoIcon } from "../assets/images/durolt_logo_new.svg";

// const BookingSummary = ({ bookingLockerHandler, selectedLockers, address, 	handleLockerBooking = () => {} }) => {

// 	console.log("selectedLockers: ",selectedLockers);
//   const lockers = [
//   ];

//   // use selectedLockers if available
// 	const lockerList =
// 		selectedLockers &&  selectedLockers.length > 0
// 		? selectedLockers
// 		: lockers;

// 	const handlerCLick = () => {
// 		bookingLockerHandler();
// 	};

// 	const handlePayment = ()=>{
// 		// make the payload for advance reserver api call and then call the login process from the lockerSize page not from here beacuse it is component so
// 		// we can use the function 
// 		handleLockerBooking()
// 		console.log("lockerList is; ", lockerList);
// 	}

// 	return (
// 	<div className="booking-summary">
// 		{/* <div className="logo">
// 			<DuroltLogoIcon width={100} height={40} />
// 		</div> */}
// 		<h2 className="title">
// 			Kindly confirm the details of your booking
// 		</h2>
// 		<div className="location">
// 			{address ? address : "Pune"}
// 		</div>
// 		{/* Scrollable section */}
// 		<div className="locker-list">
// 			{lockerList.map((locker) => (
// 				<div className="locker-card" key={locker.id}>
// 					<div className="locker-info">
// 						<span className="locker-name">{locker.name}</span>
// 						<select className="time-select">
// 						{locker.durations.map((duration, index) => (
// 							<option key={index} value={duration.price}>
// 							{duration.label}
// 							</option>
// 						))}
// 						</select>
// 						<span className="price">
// 						₹{locker.durations[0].price}
// 						</span>
// 					</div>
// 				</div>
// 			))}
// 			<div className="add-locker" onClick={handlerCLick}>
// 				Add another locker
// 			</div>
// 			<div className="total-section">
// 				<span>Total payable amount</span>
// 				<span className="total-price">
// 				₹{lockerList.reduce(
// 					(total, item) => total + item.durations[0].price,
// 					0
// 				)}
// 				</span>
// 			</div>
// 		</div>

// 		{/* Fixed Footer */}
// 		<div className="buttons">
// 			<button onClick={handlePayment} className="pay-btn">Proceed to pay</button>
// 			<button className="cancel-btn">Cancel</button>
// 		</div>
// 	</div>
// 	);
// };

// export default BookingSummary;


// import React, { useState } from "react";
// import LockerModalContent from "./LockerBookingSlotComponent";

// const BookingSummary = ({
//   bookingLockerHandler,
//   selectedLockers,
//   address,
//   handleLockerBooking = () => {},
// }) => {
//   const [showModal, setShowModal] = useState(false);
//   const [activeIndex, setActiveIndex] = useState(null);
//   const [selectedSlots, setSelectedSlots] = useState({}); // ✅ main state

//   const lockerList = selectedLockers || [];

//   const handlerCLick = () => {
//     bookingLockerHandler();
//   };

//   const handlePayment = () => {
//     console.log("🚀 Final Payload:", selectedSlots);
//     handleLockerBooking(selectedSlots);
//   };

//   // ✅ Open Modal
//   const openModal = (index) => {
//     setActiveIndex(index);
//     setShowModal(true);
//   };

//   // ✅ Save selected slot_id
//   const handleConfirmSlot = ({ slot_id }) => {
//     setSelectedSlots((prev) => ({
//       ...prev,
//       [activeIndex]: slot_id,
//     }));

//     setShowModal(false);
//   };

//   return (
//     <div className="booking-summary">
//       <h2 className="title">
//         Kindly confirm the details of your booking
//       </h2>

//       <div className="location">
//         {address ? address : "Pune"}
//       </div>

//       <div className="locker-list">
//         {lockerList.map((locker, index) => {
//           const selectedSlotId = selectedSlots[index];

//           const matchedSlot = locker.bookingSlots?.find(
//             (slot) => slot.id === selectedSlotId
//           );

//           return (
//             <div className="locker-card" key={index}>
//               <div className="locker-info">
//                 <span className="locker-name">{locker.name}</span>

//                 {/* SLOT BUTTON */}
//                 {locker?.bookingSlots ? (
//                   <button
//                     className="choose-slot-btn"
//                     onClick={() => openModal(index)}
//                   >
//                     {matchedSlot?.durationRange || "Choose Slot"}
//                   </button>
//                 ) : (
//                   <select className="time-select">
//                     {locker.durations.map((duration, i) => (
//                       <option key={i} value={duration.price}>
//                         {duration.label}
//                       </option>
//                     ))}
//                   </select>
//                 )}

//                 {/* PRICE */}
//                 <span className="price">
//                   ₹
//                   {matchedSlot?.price ??
//                     locker.durations?.[0]?.price ??
//                     0}
//                 </span>
//               </div>
//             </div>
//           );
//         })}

//         {/* ADD LOCKER */}
//         <div className="add-locker" onClick={handlerCLick}>
//           Add another locker
//         </div>

//         {/* TOTAL */}
//         <div className="total-section">
//           <span>Total payable amount</span>
//           <span className="total-price">
//             ₹
//             {lockerList.reduce((total, locker, index) => {
//               const selectedSlotId = selectedSlots[index];

//               const matchedSlot = locker.bookingSlots?.find(
//                 (slot) => slot.id === selectedSlotId
//               );

//               return (
//                 total +
//                 (matchedSlot?.price ??
//                   locker.durations?.[0]?.price ??
//                   0)
//               );
//             }, 0)}
//           </span>
//         </div>
//       </div>

//       {/* BUTTONS */}
//       <div className="buttons">
//         <button onClick={handlePayment} className="pay-btn">
//           Proceed to pay
//         </button>
//         <button className="cancel-btn">Cancel</button>
//       </div>

//       {/* MODAL */}
//       {showModal && activeIndex !== null && (
//         <LockerModalContent
//           lockerInfos={lockerList[activeIndex]}
//           selectedSlotId={selectedSlots[activeIndex]} // ✅ pass selected
//           onConfirm={handleConfirmSlot}
//           onCancel={() => setShowModal(false)}
//         />
//       )}
//     </div>
//   );
// };

// export default BookingSummary;



import React, { useState, useEffect } from "react";
import ButtonComponent from "./ButtonComponent";

const BookingSummary = ({
  bookingLockerHandler,
  selectedLockers,
  address,
  lockerCurrency = "INR",
  handleLockerBooking = () => {},
}) => {
  const [updatedLockers, setUpdatedLockers] = useState(selectedLockers || []);
  const [totalPrice, setTotalPrice] = useState(0);
    
  console.log("selectedLockers in BookingSummary: ", selectedLockers);

  // Sync lockers
  useEffect(() => {
    setUpdatedLockers(selectedLockers || []);
  }, [selectedLockers]);

  const lockerList = updatedLockers || [];

  const handlerCLick = () => {
    bookingLockerHandler();
  };

  const handlePayment = () => {
    console.log(" Final Payload:", lockerList, "Total:", totalPrice);
    handleLockerBooking(lockerList, totalPrice);
  };

  // TOTAL PRICE CALCULATION (FIXED + FALLBACK)
  useEffect(() => {
    const total = lockerList.reduce((sum, item) => {
      return (
        sum +
        Number(
          item?.selectedSlot?.price ||     // selected slot price
          item?.durations?.[0]?.price ||   // fallback duration price
          item?.price || 0                 // base fallback
        )
      );
    }, 0);

    setTotalPrice(total);
  }, [lockerList]);

  return (
    <div className="booking-summary">
      <h2 className="title">
        Kindly confirm the details of your booking
      </h2>

      <div className="location">
        {address ? address : "Pune"}
      </div>

      <div className="locker-list">
        {lockerList.map((locker) => (
          <div className="locker-card" key={locker.id}>
            <div className="locker-info">
              <span className="locker-name">{locker.name}</span>

              {/* SLOT BUTTON */}
              {locker?.bookingSlots ? (
                <button className="choose-slot-btn" disabled>
                  {locker.selectedSlot
                    ? locker.selectedSlot.durationRange
                    : "Slot Not Selected"}
                </button>
              ) : (
                <div className="time-select">
                  {locker.durations?.map((duration, index) => (
                    <p key={index}>
                      {duration.label}
                    </p>
                  ))}
                </div>
              )}

              {/* PRICE */}
              <span className="price">
                {` ${lockerCurrency} `}
                {locker?.selectedSlot?.price ||
                  locker?.durations?.[0]?.price ||
                  locker?.price}
              </span>
            </div>
          </div>
        ))}

        {/* ADD LOCKER */}
        <div className="add-locker" onClick={handlerCLick}>
          Add Another / Update Selected Locker
        </div>

        {/* TOTAL */}
        <div className="total-section">
          <span>Total payable amount</span>
          <span className="total-price"> {` ${lockerCurrency}  `} {totalPrice}</span>
        </div>
      </div>

      {/* BUTTONS */}
      <div className="buttons">
        <ButtonComponent 
          type="primary" 
          handleClick={handlePayment}
          title={"Proceed to Pay"}
        />
        {/* <button onClick={handlePayment} className="pay-btn">
          Proceed to pay
        </button> */}
        <ButtonComponent 
          type={"warning"}
          handleClick={() =>{}} 
          title={"Cancel"}
        />
      </div>

    </div>
  );
};

export default BookingSummary;

// import React, { useState, useEffect } from "react";
// import LockerModalContent from "./LockerBookingSlotComponent";

// const BookingSummary = ({
//   bookingLockerHandler,
//   selectedLockers,
//   address,
//   handleLockerBooking = () => {},
// }) => {
//   const [showModal, setShowModal] = useState(false);
//   const [activeLocker, setActiveLocker] = useState(null);
//   const [updatedLockers, setUpdatedLockers] = useState([]);

//   // ✅ GLOBAL SELECTED DURATION
//   const [selectedDuration, setSelectedDuration] = useState(null);

//   useEffect(() => {
//     setUpdatedLockers(selectedLockers || []);
//   }, [selectedLockers]);

//   const lockerList = updatedLockers || [];

//   const handlerCLick = () => {
//     bookingLockerHandler();
//   };

//   // ✅ TRANSFORM PAYLOAD
//   const transformPayload = (lockers) => {
//     return lockers
//       .filter((locker) => locker.selectedSlot) // remove invalid
//       .map((locker) => {
//         const selected = locker.selectedSlot;

//         return {
//           door_size: locker.door_size,
//           name: locker.name,
//           price: Number(selected.price),

//           durations: [
//             {
//               label: selected.durationRange,
//               price: Number(selected.price),
//             },
//           ],

//           slot_id: selected.id,
//         };
//       });
//   };

//   // ✅ PAYMENT
//   const handlePayment = () => {
//     const finalPayload = transformPayload(lockerList);

//     if (!finalPayload.length) {
//       alert("Please select slot for lockers");
//       return;
//     }

//     console.log("🚀 Final Payload:", finalPayload);
//     handleLockerBooking(finalPayload);
//   };

//   // ✅ OPEN MODAL
//   const openModal = (locker) => {
//     setActiveLocker(locker);
//     setShowModal(true);
//   };

//   // ✅ MAIN LOGIC
//   const handleConfirmSlot = ({ durationInMilliseconds }) => {
//     setSelectedDuration(durationInMilliseconds);

//     const updated = lockerList.map((locker) => {
//       const matchedSlot = locker?.bookingSlots?.find(
//         (s) => s.durationInMilliseconds === durationInMilliseconds
//       );

//       return {
//         ...locker,
//         selectedSlot: matchedSlot || null,
//       };
//     });

//     setUpdatedLockers(updated);
//     setShowModal(false);
//   };

//   return (
//     <div className="booking-summary">
//       <h2 className="title">Kindly confirm the details of your booking</h2>

//       <div className="location">{address || "Pune"}</div>

//       <div className="locker-list">
//         {lockerList.map((locker, index) => (
//           <div className="locker-card" key={index}>
//             <div className="locker-info">
//               <span className="locker-name">{locker.name}</span>

//               {/* SLOT BUTTON */}
//               {locker?.bookingSlots ? (
//                 <button
//                   className="choose-slot-btn"
//                   onClick={() => openModal(locker)}
//                 >
//                   {locker.selectedSlot
//                     ? locker.selectedSlot.durationRange
//                     : "Choose Slot"}
//                 </button>
//               ) : null}

//               {/* PRICE */}
//               <span className="price">
//                 ₹ {Number(locker?.selectedSlot?.price || 0)}
//               </span>
//             </div>
//           </div>
//         ))}

//         {/* ADD LOCKER */}
//         <div className="add-locker" onClick={handlerCLick}>
//           Add another locker
//         </div>

//         {/* TOTAL */}
//         <div className="total-section">
//           <span>Total payable amount</span>
//           <span className="total-price">
//             ₹{" "}
//             {lockerList.reduce(
//               (total, item) =>
//                 total + Number(item?.selectedSlot?.price || 0),
//               0
//             )}
//           </span>
//         </div>
//       </div>

//       {/* BUTTONS */}
//       <div className="buttons">
//         <button onClick={handlePayment} className="pay-btn">
//           Proceed to pay
//         </button>
//         <button className="cancel-btn">Cancel</button>
//       </div>

//       {/* MODAL */}
//       {showModal && activeLocker && (
//         <LockerModalContent
//           lockerInfos={activeLocker}
//           selectedDuration={selectedDuration}
//           onConfirm={handleConfirmSlot}
//           onCancel={() => setShowModal(false)}
//         />
//       )}
//     </div>
//   );
// };

// export default BookingSummary;
